import IncodeFaceAuth from "./components/IncodeLivenessComponent";

interface IncodeLivenessProps {
    livenessSessionId: string;
    sessionId: string;
    sessionToken: string;
    interviewId: string;
    apiUrl: string;
    onConnectionError?: () => void;
    personUuid?: string;
    vendor?: string;
}

export default function IncodeLiveness({ livenessSessionId, sessionId, sessionToken, interviewId, apiUrl, onConnectionError, personUuid, vendor }: IncodeLivenessProps) {
    return (
        <IncodeFaceAuth
            apiUrl={apiUrl}
            identityId={sessionId}
            sessionToken={sessionToken}
            interviewId={interviewId}
            livenessSessionId={livenessSessionId}
            onConnectionError={onConnectionError}
            personUuid={personUuid}
            vendor={vendor}
        />
    )
}
